import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-turns-desk-new-schedule',
  templateUrl: './turns-desk-new-schedule.component.html',
  styleUrls: ['./turns-desk-new-schedule.component.scss']
})
export class TurnsDeskNewScheduleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
